export default __webpack_public_path__ + "static/istio-adapter-d979dac07625c10542f2e92ae665270f.webp";